import React, { useEffect, useState } from "react";
import { generateInputTag, getFormValue, getInputDataType, getSelectOptions } from "components/DynamicForm/utils";
import { Alert, Button, Table } from "reactstrap";
import { errorHandler } from "utils/Api";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import styles from "./style.module.scss";
import cx from "classnames";
import { SELECT_INPUT_TYPE } from "utils/Constants";
import InputLabel from "../InputLabel";

const JsonTableInput = (props) => {
  const { legend, description, className, dataSchema, onChange, disabled = false, onBlur, addBtnAction, editBtnAction, deleteBtnAction, addBtn,
    inputErrors = false, inputProps, value = "{}", defaultValue = "", showDivisor = true, editable = true } = props;
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (value) {
      let newValue = []
      try {
        newValue = JSON.parse(value);
      } catch (e) {
        errorHandler(e, "JsonTableInput Json Parse Eror");
      }
      setTableData(newValue);
    } else if (defaultValue) {
      setTableData(defaultValue);
    }
  }, [value, defaultValue]);

  const getTableHeading = () => {
    const headings = Object.values(dataSchema).map(d => (
      <th className={d.headingWidth}> {d.label}</th>
    ));

    return (<tr>
      {headings}
      <th>
        {!disabled && getHeadingButtons()}
      </th>
    </tr>
    );
  }

  const getHeadingButtons = () => {
    if (addBtn) {
      return addBtn;
    }

    const addCallback = addBtnAction ? addBtnAction : addRowEntry;
    return (
      <Button className={styles.plusButton} type="button" color="success" onClick={addCallback}> <AddIcon /> </Button>
    )
  }

  const addRowEntry = () => {
    const newTableData = [
      ...tableData,
      {}
    ]
    setTableData(newTableData);
    triggerOnChange(newTableData);
  }

  const getTableInput = (name, index, data, inputConfig) => {
    const inputData = { ...inputConfig, name };
    if (editable) {
      const fakeFormik = {
        handleBlur: triggerOnBlur
      }
      return generateInputTag("", inputData, data, (name, value) => setTableRowData(name, index, value), fakeFormik);
    } else {
      const dataType = getInputDataType(inputData);
      const selectOptions = getSelectOptions(inputConfig.options, inputConfig.type);
      const formValue = getFormValue(name, dataType, selectOptions, inputData, data, inputData);

      if (inputData.suffix)
        return `${formValue} ${inputData.suffix}`;
      if (inputData.type === "money")
        return `${formValue} $`;
      if (dataType === SELECT_INPUT_TYPE)
        return formValue.label;
      return formValue;
    }
  }

  const getTableContent = () => {
    const inputsName = Object.keys(dataSchema);
    return tableData.map((d, index) => {
      return (
        <tr key={`row-${index}`}>
          {
            inputsName.map((name) => {
              return (
                <td key={`row-${index}-${name}`}>
                  {getTableInput(name, index, d, dataSchema[name])}
                </td>
              );
            })
          }
          <td>
            <div className={
              cx(
                {
                  [styles['tableButtons--single']]: editBtnAction == undefined,
                  [styles.tableButtons]: true
                })
            }>
              {!disabled && editBtnAction && (
                <Button
                  className={styles.editButton}
                  type="button"
                  color="primary"
                  onClick={(e) => editBtnAction(d)} >
                  <EditIcon />
                </Button>
              )}
              {!disabled && (
                <Button
                  className={styles.deleteButton}
                  type="button"
                  color="danger"
                  onClick={(e) => deleteEntry(index, d)} >
                  <DeleteIcon />
                </Button>
              )}
            </div>
          </td>
        </tr >
      )

    });
  }

  const deleteEntry = (entryIndex, data) => {
    if (deleteBtnAction) {
      deleteBtnAction(data);
    } else {
      let newTableData = [...tableData];
      newTableData = newTableData.filter(function (data, index) {
        return index !== entryIndex;
      });
      setTableData(newTableData);
      triggerOnChange(newTableData);
    }
  }

  const setTableRowData = (name, index, value) => {
    let newTableData = [...tableData];
    newTableData[index][name] = value;
    setTableData(newTableData);
    triggerOnChange(newTableData);
  }

  const triggerOnChange = (newTableData) => {
    if (onChange) {
      onChange(JSON.stringify(newTableData));
    }
  }

  const triggerOnBlur = (e) => {
    if (onBlur) {
      e.target.name = inputProps.name;
      onBlur(e);
    }
  }

  return (
    <div>
      {showDivisor && (<hr />)}
      <InputLabel tag="h4" description={description}>
        {legend}
      </InputLabel>
      <Table
        className={cx(
          {
            [`mb-0`]: true,
            "is-invalid": inputErrors,
            className: className
          }
        )} >
        <thead>
          {getTableHeading()}
        </thead>
        <tbody className={styles.tableBody}>
          {getTableContent()}
        </tbody>
      </Table>
      {inputErrors && (
        <Alert color="danger">
          <div className="is-invalid" />
          {inputErrors}
        </Alert>
      )}
    </div>
  );
}

export default JsonTableInput;